export const filterContents = (removeFromTheSidebar, items) => {
    return  items && items.filter((item) => item.link && !includeCustom(removeFromTheSidebar, item.link)); 
}

const includeCustom = (array,  link) => {
    let include = false; 
    for (let index = 0; index < array.length; index++) {
        const element = array[index];
        if(element.link === link && !element.active){
            include = true;
        }
    }
    return include; 
}
